import React from 'react';

function Footer() {
    return (
        <footer>
            <p>&copy; {new Date().getFullYear()} My Personal Websitte</p>
        </footer>
    );
}

export default Footer;
